import { apiCall, baseUrl, exportFileCall } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  addGroupMock,
  cotutorsListMock,
  groupListGetMock,
  quizDetailsMock,
  quizcreateMock,
  successMock,
  tagListGetMock,
  surveyListGetMock,
  tutorsListMock,
  userListGetMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { authPath, coursePath, groupsPath, quizPath } from '../../utils/paths';

export default {
  tutorsListGet: (id) => {
    if (shouldUseMock()) {
      return tutorsListMock();
    }
    return apiCall(
      `${baseUrl}${groupsPath}tutor/list${parseQueryParams({ nid: id })}`,
      'GET'
    );
  },
  cotutorsListGet: (id) => {
    if (shouldUseMock()) {
      return cotutorsListMock();
    }
    return apiCall(
      `${baseUrl}${groupsPath}cotutor/list${parseQueryParams({ nid: id })}`,
      'GET'
    );
  },
  tagListGet: (filters) => {
    if (shouldUseMock()) {
      return tagListGetMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}tag/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  surveyListGet: (id, typology) => {
    if (shouldUseMock()) {
      return surveyListGetMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}survey/list?parent_categories=${id}&typology=${typology}`,
      'GET'
    );
  },
  quizCreate: (payload) => {
    if (shouldUseMock()) {
      return quizcreateMock();
    }
    return apiCall(`${baseUrl}${quizPath}quiz/create`, 'POST', payload);
  },
  quizUpdate: (quizId, body) => {
    if (shouldUseMock()) {
      return quizcreateMock();
    }
    return apiCall(`${baseUrl}${quizPath}quiz/${quizId}/update`, 'POST', body);
  },
  quizDetailsGet: (id) => {
    if (shouldUseMock()) {
      return quizDetailsMock();
    }
    return apiCall(`${baseUrl}${quizPath}quiz/${id}/update`, 'GET');
  },
  userListGet: (payload) => {
    if (shouldUseMock()) {
      return userListGetMock();
    }
    return apiCall(
      `${baseUrl}${authPath}user/list${parseQueryParams(payload)}`,
      'GET'
    );
  },
  groupListGet: (filters) => {
    if (shouldUseMock()) {
      return groupListGetMock();
    }
    return apiCall(
      `${baseUrl}${groupsPath}group/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  newGroupAdd: (payload) => {
    if (shouldUseMock()) {
      return addGroupMock();
    }
    return apiCall(`${baseUrl}${groupsPath}group/create`, 'POST', payload);
  },
  groupEdit: (id, payload) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${groupsPath}group/${id}/update`,
      'POST',
      payload
    );
  },
  groupImportTemplateGet: (type) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${groupsPath}group/template/download?type=${type}`,
      method: 'GET',
      filename: `import_template_${type}.csv`,
    });
  },
  courseCreate: (payload) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${coursePath}course/create`, 'POST', payload);
  },
  courseUpdate: (id, payload) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}course/${id}/update`,
      'POST',
      payload
    );
  },
  quizDelete: (id) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${quizPath}quiz/${id}/delete`, 'POST', {
      action: true,
    });
  },
  groupDelete: (id) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${groupsPath}group/${id}/delete`, 'POST', {
      action: true,
    });
  },
};
